export default {
  // Common
  common: {
    welcome: 'Bem-vindo',
    loading: 'Carregando...',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    search: 'Pesquisar...',
    filter: 'Filtrar',
    export: 'Exportar',
    refresh: 'Atualizar',
    back: 'Voltar',
    next: 'Próximo',
    previous: 'Anterior',
    confirm: 'Confirmar',
    yes: 'Sim',
    no: 'Não',
    close: 'Fechar',
    actions: 'Ações',
    status: 'Status',
    active: 'Ativo',
    inactive: 'Inativo',
    enabled: 'Habilitado',
    disabled: 'Desabilitado',
    success: 'Sucesso',
    error: 'Erro',
    warning: 'Aviso',
    info: 'Informação',
    apply: 'Aplicar',
    download: 'Baixar',
    upload: 'Enviar',
    view: 'Visualizar',
    details: 'Detalhes',
    name: 'Nome',
    email: 'E-mail',
    phone: 'Telefone',
    address: 'Endereço',
    country: 'País',
    city: 'Cidade',
    state: 'Estado',
    zipCode: 'CEP',
    createdAt: 'Criado em',
    updatedAt: 'Atualizado em',
    description: 'Descrição',
    type: 'Tipo',
    amount: 'Valor',
    date: 'Data',
    time: 'Hora',
    from: 'De',
    to: 'Para',
    all: 'Todos',
    none: 'Nenhum',
    select: 'Selecionar',
    selected: 'Selecionado',
    total: 'Total',
    subtotal: 'Subtotal',
    pending: 'Pendente',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
    completed: 'Concluído',
    failed: 'Falhou',
    processing: 'Processando',
    cancelled: 'Cancelado',
    required: 'Obrigatório',
    optional: 'Opcional',
    today: 'Hoje',
    yesterday: 'Ontem',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mês',
    lastMonth: 'Mês passado',
    custom: 'Personalizado',
    range: 'Intervalo',
    noData: 'Sem dados disponíveis',
    noResults: 'Nenhum resultado encontrado',
    showMore: 'Mostrar mais',
    showLess: 'Mostrar menos',
    expand: 'Expandir',
    collapse: 'Recolher',
    clearAll: 'Limpar tudo',
    selectAll: 'Selecionar tudo',
    deselectAll: 'Desmarcar tudo',
    copyToClipboard: 'Copiar para área de transferência',
    copied: 'Copiado!',
    notAvailable: 'N/D',
    upgrade: 'Atualizar',
  },

  // Auth
  auth: {
    login: 'Entrar',
    logout: 'Sair',
    email: 'E-mail',
    password: 'Senha',
    rememberMe: 'Lembrar-me',
    forgotPassword: 'Esqueceu a senha?',
    signIn: 'Entrar',
    signUp: 'Cadastrar',
    loginSuccess: 'Login realizado com sucesso',
    loginError: 'E-mail ou senha inválidos',
    sessionExpired: 'Sessão expirada. Por favor, entre novamente.',
    adminPanel: 'Painel Administrativo',
    needHelp: 'Precisa de ajuda?',
    poweredBy: 'Desenvolvido por',
  },

  // Navigation
  nav: {
    dashboard: 'Painel',
    instruments: 'Instrumentos',
    clients: 'Clientes',
    accounts: 'Contas',
    trading: 'Negociação',
    reports: 'Relatórios',
    auditLog: 'Log de Auditoria',
    withdrawals: 'Saques',
    deposits: 'Depósitos',
    settings: 'Configurações',
    plugins: 'Plugins',
    accountGroups: 'Grupos de Contas',
    kyc: 'KYC',
    apiDocs: 'Docs da API',
    notifications: 'Notificações',
    upgrade: 'Atualizar',
    groupPricing: 'Preços por Grupo',
  },

  // Dashboard
  dashboard: {
    title: 'Painel',
    overview: 'Visão Geral',
    stats: 'Estatísticas',
    totalClients: 'Total de Clientes',
    totalAccounts: 'Total de Contas',
    openPositions: 'Posições Abertas',
    todayPnL: 'L&P de Hoje',
    liveAccounts: 'Contas Reais',
    demoAccounts: 'Contas Demo',
    activeClients: 'Clientes Ativos',
    activeTraders: 'Traders Ativos',
    newClients: 'Novos Clientes',
    volumeChart: 'Volume de Negociação (7 Dias)',
    pnlTrend: 'Tendência de L&P (30 Dias)',
    recentActivity: 'Atividade Recente',
    quickActions: 'Ações Rápidas',
    financialOverview: 'Visão Financeira',
    financialOverview30Days: 'Visão Financeira (30 Dias)',
    riskAlerts: 'Alertas de Risco',
    riskDistribution: 'Distribuição de Risco',
    currentPlan: 'Plano Atual',
    planUsage: 'Uso do Plano',
    allowedMarkets: 'Mercados Permitidos',
    accountOverview: 'Visão das Contas',
    activeUsers: 'Usuários Ativos',
    activeThisMonth: 'Ativos Este Mês',
    plan: 'plano',
    feedLatency: 'Latência do Feed',
    expires: 'Expira em',
    cashFlowComparison: 'Comparação de Fluxo de Caixa',
    totalTransactions: 'total de transações',
    totalDeposits: 'total de depósitos',
    totalWithdrawals: 'total de saques',
  },

  // Instruments
  instruments: {
    title: 'Gestão de Instrumentos',
    library: 'Biblioteca de Instrumentos',
    enabled: 'Instrumentos Habilitados',
    feed: 'Instrumentos do Feed',
    symbol: 'Símbolo',
    category: 'Categoria',
    priceScale: 'Escala de Preço',
    leverage: 'Alavancagem',
    spread: 'Spread',
    commission: 'Comissão',
    enable: 'Habilitar',
    disable: 'Desabilitar',
    bulkEnable: 'Habilitar em Massa',
    settings: 'Configurações',
    tradeMode: 'Modo de Negociação',
    executionType: 'Tipo de Execução',
    forex: 'Forex',
    crypto: 'Cripto',
    stocks: 'Ações',
    indices: 'Índices',
    commodities: 'Commodities',
    general: 'Geral',
    leverageLots: 'Alavancagem e Lotes',
    spreads: 'Spreads',
    commissions: 'Comissões',
    riskManagement: 'Gestão de Risco',
    advanced: 'Avançado',
    maxLeverage: 'Alavancagem Máxima',
    minLotSize: 'Tamanho Mínimo de Lote',
    maxLotSize: 'Tamanho Máximo de Lote',
    lotStep: 'Incremento de Lote',
    spreadType: 'Tipo de Spread',
    spreadMarkup: 'Markup de Spread',
    fixedSpread: 'Spread Fixo',
    commissionPerLot: 'Comissão por Lote',
    commissionType: 'Tipo de Comissão',
    stopLevel: 'Nível de Stop',
    freezeLevel: 'Nível de Congelamento',
    maxPositions: 'Máximo de Posições',
    enableSuccess: 'Instrumento habilitado com sucesso',
    disableSuccess: 'Instrumento desabilitado com sucesso',
    updateSuccess: 'Configurações atualizadas com sucesso',
    bulkEnableSuccess: 'Instrumentos habilitados com sucesso',
  },

  // Clients
  clients: {
    title: 'Clientes',
    clientsList: 'Lista de Clientes',
    clientDetails: 'Detalhes do Cliente',
    name: 'Nome',
    email: 'E-mail',
    phone: 'Telefone',
    country: 'País',
    kycStatus: 'Status KYC',
    accountCount: 'Contas',
    totalBalance: 'Saldo Total',
    lastLogin: 'Último Login',
    createdAt: 'Criado em',
    verified: 'Verificado',
    pending: 'Pendente',
    rejected: 'Rejeitado',
    searchPlaceholder: 'Pesquisar clientes...',
    nameOrEmail: 'Nome ou e-mail…',
    editClient: 'Editar cliente',
    configureOverride: 'Configurar substituição de usuário',
    noClientsFound: 'Nenhum cliente encontrado',
  },

  // Accounts
  accounts: {
    title: 'Contas',
    accountsList: 'Lista de Contas',
    accountDetails: 'Detalhes da Conta',
    accountNumber: 'Número da Conta',
    accountType: 'Tipo de Conta',
    accountGroup: 'Grupo de Conta',
    accountSettings: 'Configurações da Conta',
    accountState: 'Estado da Conta',
    accountActive: 'Conta Ativa',
    balance: 'Saldo',
    equity: 'Patrimônio',
    margin: 'Margem',
    freeMargin: 'Margem Livre',
    marginLevel: 'Nível de Margem',
    leverage: 'Alavancagem',
    credit: 'Crédito',
    debit: 'Débito',
    adjustBalance: 'Ajustar Saldo',
    changeLeverage: 'Alterar Alavancagem',
    live: 'Real',
    demo: 'Demo',
    searchPlaceholder: 'Pesquisar por número de conta ou e-mail...',
    accountNumberOrEmail: 'Número de conta ou e-mail…',
    balanceChange: 'Alteração de Saldo',
    reasonForAdjustment: 'Motivo do ajuste...',
    accountUpdatedSuccess: 'Conta atualizada com sucesso',
    noAccountsFound: 'Nenhuma conta encontrada',
  },

  // Trading
  trading: {
    title: 'Negociação',
    positions: 'Posições',
    orders: 'Ordens',
    history: 'Histórico',
    symbol: 'Símbolo',
    side: 'Lado',
    volume: 'Volume',
    openPrice: 'Preço de Abertura',
    currentPrice: 'Preço Atual',
    pnl: 'L&P',
    buy: 'Comprar',
    sell: 'Vender',
    open: 'Aberto',
    pending: 'Pendente',
    closed: 'Fechado',
    closedAt: 'Fechado em',
    openedAt: 'Aberto em',
    price: 'Preço',
    totalTrades: 'Total de Negociações',
    winningTrades: 'Negociações Vencedoras',
    losingTrades: 'Negociações Perdedoras',
    totalPnL: 'L&P Total',
    account: 'Conta',
    status: 'Status',
    swap: 'Swap',
    commission: 'Comissão',
    ticket: 'Ticket',
    noPositions: 'Nenhuma posição aberta encontrada',
    noOrders: 'Nenhuma ordem pendente encontrada',
    noHistory: 'Nenhum histórico de negociação encontrado',
    bid: 'Bid',
    ask: 'Ask',
    tradingManagement: 'Gestão de Negociação',
    liveMonitoring: 'Monitoramento ao Vivo',
    disconnected: 'Desconectado',
    activeTraders: 'Traders Ativos',
    openPositions: 'Posições Abertas',
    pendingOrders: 'Ordens Pendentes',
    floatPnL: 'L&P Flutuante',
    accountState: 'Estado da Conta',
    marginCall: 'CHAMADA DE MARGEM',
    stopOutRisk: 'RISCO DE STOP OUT',
    live: 'AO VIVO',
    offline: 'OFFLINE',
    snapshot: 'INSTANTÂNEO',
    marginLvl: 'Nível de Margem',
    openTrades: 'Negociações Abertas',
    freeMargin: 'Margem Livre',
    marginUsed: 'Margem Utilizada',
    balance: 'Saldo',
    equity: 'Patrimônio',
    credit: 'Crédito',
    slTp: 'SL / TP',
    fees: 'Taxas',
    netPnL: 'L&P Líquido',
    grossPnL: 'L&P Bruto',
    reason: 'Motivo',
    openedClosed: 'Aberto / Fechado',
    closePrice: 'Preço de Fechamento',
    reserved: 'Reservado',
    reservedMargin: 'Margem Reservada',
    created: 'Criado',
    triggerPrice: 'Preço de Gatilho',
    duration: 'Duração',
    closedTrades: 'Negociações Fechadas',
    activeTrades: 'Ativas',
    stopLoss: 'Stop Loss',
    takeProfit: 'Take Profit',
    closePosition: 'Fechar Posição',
    cancelOrder: 'Cancelar Ordem',
    modifyPosition: 'Modificar Posição',
    thisActionCannotBeUndone: 'Esta ação não pode ser desfeita',
    enterStopLoss: 'Insira o preço de stop loss',
    enterTakeProfit: 'Insira o preço de take profit',
    filterTrading: 'Filtrar Negociação',
    traderSymbolAccount: 'Trader, símbolo, conta…',
    noFound: 'Nenhum(a) {tab} encontrado(a)',
    showingOf: 'Exibindo {from}–{to} de {total} traders',
    traderCount: '{count} trader(s) · {total} {tab}',
    positionClosedSuccess: 'Posição fechada com sucesso',
    orderCancelledSuccess: 'Ordem cancelada com sucesso',
    positionModifiedSuccess: 'Posição modificada com sucesso',
    failedToClosePosition: 'Falha ao fechar posição',
    failedToCancelOrder: 'Falha ao cancelar ordem',
    failedToModifyPosition: 'Falha ao modificar posição',
    invalidPosition: 'Posição inválida: ID ausente',
  },

  // Reports
  reports: {
    title: 'Relatórios',
    exposure: 'Relatório de Exposição',
    profitability: 'Lucratividade do Cliente',
    daily: 'Relatório Diário',
    dateRange: 'Intervalo de Datas',
    totalExposure: 'Exposição Total',
    netVolume: 'Volume Líquido',
    topWinners: 'Maiores Ganhadores',
    topLosers: 'Maiores Perdedores',
    buyVolume: 'Volume de Compra',
    sellVolume: 'Volume de Venda',
    positionCount: 'Quantidade de Posições',
    winRate: 'Taxa de Acerto',
    rank: 'Posição',
    client: 'Cliente',
    noData: 'Sem dados disponíveis',
    totalVolume: 'Volume Total',
    commission: 'Comissão',
    activeAccounts: 'Contas Ativas',
    export: 'Exportar',
    download: 'Baixar',
    positions: 'Posições',
    trades: 'Negociações',
    winning: 'Vencedoras',
    losing: 'Perdedoras',
  },

  // Settings
  settings: {
    title: 'Configurações',
    brokerInfo: 'Informações da Corretora',
    brokerSettings: 'Configurações da Corretora',
    brokerName: 'Nome da Corretora',
    brokerNameRequired: 'Nome da Corretora *',
    brokerLogo: 'Logo da Corretora',
    brokerStatus: 'Status da Corretora',
    domain: 'Domínio',
    primaryColor: 'Cor Principal',
    secondaryColor: 'Cor Secundária',
    logo: 'Logo',
    supportEmail: 'E-mail de Suporte',
    supportPhone: 'Telefone de Suporte',
    generalInfo: 'Informações Gerais',
    branding: 'Identidade Visual',
    accountGroups: 'Grupos de Contas',
    addNewGroup: 'Adicionar Novo Grupo',
    createFirstGroup: 'Criar Seu Primeiro Grupo',
    noGroupsFound: 'Nenhum grupo de contas encontrado',
    default: 'Padrão',
    maxLeverage: 'Alavancagem Máxima',
    marginCall: 'Chamada de Margem',
    stopOut: 'Stop Out',
    commission: 'Comissão',
    maxLotSize: 'Tamanho Máximo de Lote',
    execution: 'Execução',
    hedgingAllowed: 'Hedge Permitido',
    scalpingAllowed: 'Scalping Permitido',
    eaTrading: 'Negociação com EA',
    nbpEnabled: 'NBP Habilitado',
    saving: 'Salvando...',
    groupName: 'Nome do Grupo',
    description: 'Descrição',
    editGroup: 'Editar Grupo',
    deleteGroup: 'Excluir Grupo',
    cannotDeleteDefault: 'Não é possível excluir o grupo padrão',
    confirmDelete: 'Tem certeza que deseja excluir "{name}"? Esta ação não pode ser desfeita.',
    groupCreatedSuccess: 'Grupo criado com sucesso',
    groupUpdatedSuccess: 'Grupo atualizado com sucesso',
    groupDeletedSuccess: 'Grupo excluído com sucesso',
    failedToSave: 'Falha ao salvar grupo',
    failedToDelete: 'Falha ao excluir grupo',
    failedToLoad: 'Falha ao carregar grupos de contas',
    configureYourBroker: 'Configure as informações e preferências da sua corretora',
    loadingSettings: 'Carregando configurações...',
    legalName: 'Nome Jurídico',
    licenseNumber: 'Número de Licença',
    environment: 'Ambiente',
    contactInformation: 'Informações de Contato',
    readOnly: 'Somente leitura',
    readOnlyContactSupport: 'Somente leitura — entre em contato com o suporte para alterar',
    supportedLanguages: 'Idiomas Suportados',
    selectLanguagesDescription: 'Selecione quais idiomas estão disponíveis no portal do cliente. Pelo menos um idioma deve ser selecionado.',
    systemLimits: 'Limites do Sistema',
    maxAccounts: 'Máximo de Contas',
    maxConcurrentTrades: 'Máximo de Negociações Simultâneas',
    maintenanceMode: 'Modo de Manutenção',
    enableMaintenanceMode: 'Habilitar Modo de Manutenção',
    maintenanceModeDescription: 'Quando habilitado, os clientes verão a mensagem de manutenção em vez da plataforma',
    maintenanceMessage: 'Mensagem de Manutenção',
    maintenanceMessagePlaceholder: 'Estamos realizando manutenção programada. Por favor, volte em breve.',
    saveChanges: 'Salvar Alterações',
    howToConnectDomain: 'Como conectar seu domínio',
    unlockToEdit: 'Desbloquear para editar domínio',
    lockDomain: 'Bloquear domínio',
    changingDomainWarning: 'Alterar seu domínio pode interromper o acesso dos clientes. Tem certeza que deseja desbloquear?',
    changingDomainWarningLong: 'Alterar seu domínio pode interromper temporariamente o acesso dos clientes e as configurações de DNS. Tem certeza que deseja desbloquear?',
    domainBreakWarning: '⚠️ Alterar o domínio pode interromper temporariamente o acesso dos clientes existentes',
    domainBreakWarningLong: '⚠️ Alterar o domínio pode interromper temporariamente o acesso dos clientes e o roteamento DNS',
  },

  // Account Groups
  accountGroups: {
    title: 'Grupos de Contas',
    activeGroups: 'ativo(s)',
    defaultGroups: 'padrão',
    addNewGroup: 'Adicionar Novo Grupo',
    createFirstGroup: 'Criar Seu Primeiro Grupo',
    noGroupsFound: 'Nenhum grupo de contas encontrado',
    groupDetails: 'Detalhes do Grupo',
    pricingOverrides: 'Substituições de Preço',
    riskSettings: 'Configurações de Risco',
    tradingSettings: 'Configurações de Negociação',
  },

  // Group Pricing
  groupPricing: {
    title: 'Substituições de Preço do Grupo',
    infoBanner: 'Substituições de Preço do Grupo de Contas',
    infoDescription: 'Configure preços personalizados para grupos de contas inteiros. Deixe os campos vazios (NULL) para usar os padrões da corretora.',
    editPricingOverrides: 'Editar Substituições de Preço',
    spreadMarkup: 'Markup de Spread',
    spreadMarkupPips: 'Markup de Spread (pips)',
    commission: 'Comissão',
    commissionPerLot: 'Comissão por Lote (USD)',
    maxLeverageOverride: 'Substituição de Alavancagem Máxima',
    brokerDefault: 'Padrão da Corretora',
    useBrokerDefault: 'Usar Padrão da Corretora',
    clearUseBrokerDefault: 'Limpar (usar padrão da corretora)',
    saveOverrides: 'Salvar Substituições',
    overridesUpdatedSuccess: 'Substituições de preço do grupo atualizadas com sucesso',
    failedToUpdate: 'Falha ao atualizar substituições',
    leaveEmptyInfo: 'Deixe os campos vazios para usar os padrões da corretora. Defina apenas valores que devem substituir este grupo.',
    pips: 'pips',
    perLot: '/lote',
  },

  // KYC
  kyc: {
    title: 'Painel KYC',
    allKyc: 'Todos os KYC',
    allStatus: 'Todos os Status',
    allKycStatus: 'Todos os Status KYC',
    pending: 'Pendente',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
    verified: 'Verificado',
    actionNeeded: 'Ação necessária',
    awaitingAction: 'Aguardando ação',
    allCaughtUp: 'Tudo em dia!',
    noApplications: 'Nenhuma solicitação de KYC pendente no momento.',
    searchPlaceholder: 'Pesquisar por nome, e-mail ou ID...',
    nameEmailOrId: 'ID, nome ou e-mail…',
    confirmApproval: 'Confirmar aprovação do KYC',
    confirmRejection: 'Confirmar rejeição — insira um motivo (obrigatório).',
    rejectionReason: 'Explique por que esta solicitação está sendo rejeitada (obrigatório)',
    approveSuccess: 'KYC aprovado com sucesso',
    rejectSuccess: 'KYC rejeitado com sucesso',
    failedToApprove: 'Falha ao aprovar KYC',
    failedToReject: 'Falha ao rejeitar KYC',
    basicVerified: 'Verificação Básica',
    fullVerified: 'Verificação Completa',
    allApplications: 'Todas as Solicitações',
    kycVerification: 'Verificação KYC',
    reviewManageDesc: 'Revisar e gerenciar solicitações de verificação de clientes',
    pluginSettings: 'Configurações do Plugin',
    reviewKycApplication: 'Revisar Solicitação KYC',
    verificationLevel: 'Nível de Verificação',
    personalInformation: 'Informações Pessoais',
    fullName: 'Nome Completo',
    dateOfBirth: 'Data de Nascimento',
    nationality: 'Nacionalidade',
    addressLabel: 'Endereço',
    sourceOfFunds: 'Origem dos Fundos',
    noPersonalData: 'Nenhum dado pessoal enviado ainda',
    uploadedDocuments: 'Documentos Enviados',
    noDocumentsUploaded: 'Nenhum documento enviado ainda',
    yourDecision: 'Sua Decisão',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    rejectionReasonLabel: 'Motivo da Rejeição',
    submitting: 'Enviando…',
    submitReview: 'Enviar Revisão',
    previewNotAvailable: 'Visualização não disponível',
    downloadFile: 'Baixar Arquivo',
    uploaded: 'Enviado',
    pendingReview: 'Aguardando Revisão',
    allLevels: 'Todos os Níveis',
    allStatuses: 'Todos os Status',
    allActions: 'Todas as Ações',
    userCol: 'Usuário',
    currentLevel: 'Nível Atual',
    docsCol: 'Docs',
    lastUpdated: 'Última Atualização',
    levelCol: 'Nível',
    actionCol: 'Ação',
    performedBy: 'Realizado por',
    detailsCol: 'Detalhes',
    dateTime: 'Data e Hora',
    submittedCol: 'Enviado em',
    noApplicationsFound: 'Nenhuma solicitação encontrada',
    noAuditRecords: 'Nenhum registro de auditoria encontrado',
    noMatchingApplications: 'Nenhuma solicitação correspondente',
    noPendingApplications: 'Nenhuma solicitação pendente',
    systemAuto: 'Sistema (Automático)',
    admin: 'Administrador',
    traderLabel: 'Trader',
    upgradedTo: 'Atualizado para',
    pendingApplications: 'solicitação pendente',
    pendingApplicationsPlural: 'solicitações pendentes',
    users: 'usuário',
    usersPlural: 'usuários',
    records: 'registro',
    recordsPlural: 'registros',
    applications: 'solicitação',
    applicationsPlural: 'solicitações',
    totalUsers: 'Total de Usuários',
    basicVerifiedStat: 'Verificação Básica',
    moderateVerified: 'Verificação Moderada',
    fullyVerified: 'Totalmente Verificado',
    pendingSuffix: '+{count} pendente(s)',
    levelBasic: 'Básico',
    levelModerate: 'Moderado',
    levelVerified: 'Verificado',
    notStarted: 'Não iniciado',
    none: 'Nenhum',
    unknown: 'Desconhecido',
    review: 'Revisar',
    auditLog: 'Log de Auditoria',
    requiredDocuments: 'Documentos Obrigatórios',
    requiredDocsDesc: 'Selecione quais documentos os traders devem enviar para cada nível de KYC. Pelo menos um documento é obrigatório por nível.',
    kycDocuments: 'Documentos KYC {level}',
    selected: '{count} selecionado(s)',
    approvalMode: 'Modo de Aprovação',
    manualReview: 'Revisão Manual',
    autoApprove: 'Aprovação Automática',
    autoApproveLevels: 'Níveis de Aprovação Automática',
    basicKyc: 'KYC Básico',
    moderateKyc: 'KYC Moderado',
    verifiedKyc: 'KYC Verificado',
    enforceOnDeposit: 'Exigir KYC em Depósitos',
    enforceOnWithdrawal: 'Exigir KYC em Saques',
    basic: 'Básico',
    moderate: 'Moderado',
    verified: 'Verificado',
    howItWorks: 'Como funciona:',
    howItWorksBullet1: 'Valores abaixo do limite básico: KYC não necessário',
    howItWorksBullet2: 'Valores acima do básico: KYC básico necessário',
    howItWorksBullet3: 'Valores acima do moderado: KYC moderado necessário',
    howItWorksBullet4: 'Valores acima do verificado: Verificação completa necessária',
    saveConfiguration: 'Salvar Configuração',
    savingConfiguration: 'Salvando...',
    openKycDashboard: 'Abrir Painel KYC',
    enableToViewStats: 'Habilite o plugin para ver as estatísticas',
    statNone: 'Nenhum',
    docGovIdFrontLabel: 'Documento de Identidade (Frente)',
    docGovIdFrontDesc: 'Passaporte, CNH ou RG — frente',
    docGovIdBackLabel: 'Documento de Identidade (Verso)',
    docGovIdBackDesc: 'Verso do documento de identidade',
    docSelfieLabel: 'Selfie com Documento',
    docSelfieDesc: 'Foto segurando o documento ao lado do rosto',
    docProofAddressLabel: 'Comprovante de Endereço',
    docProofAddressDesc: 'Conta de serviço ou extrato bancário (menos de 3 meses)',
    docBankStatementLabel: 'Extrato Bancário',
    docBankStatementDesc: 'Extrato recente com nome e conta',
    docSourceFundsLabel: 'Origem dos Fundos',
    docSourceFundsDesc: 'Documento comprovando a origem dos fundos de negociação',
    docEmploymentLabel: 'Carta de Emprego',
    docEmploymentDesc: 'Carta de confirmação do empregador',
    docTaxIdLabel: 'Documento de CPF/CNPJ',
    docTaxIdDesc: 'Certificado de identificação fiscal',
    docOtherLabel: 'Outros Documentos',
    docOtherDesc: 'Documentos de suporte adicionais',
    auditActions: {
      submitted: 'Enviado',
      approved: 'Aprovado',
      rejected: 'Rejeitado',
      document_uploaded: 'Doc Enviado',
      document_approved: 'Doc Aprovado',
      document_rejected: 'Doc Rejeitado',
      level_upgraded: 'Nível Atualizado',
      resubmission: 'Reenvio',
    },
  },

  // Deposits
  deposits: {
    title: 'Depósitos',
    allDeposits: 'Todos os Depósitos',
    allStatuses: 'Todos os Status',
    pending: 'Pendente',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
    completed: 'Concluído',
    searchPlaceholder: 'Pesquisar depósitos…',
    searchByIdNameEmail: 'Pesquisar por ID, nome do trader ou e-mail…',
    idNameOrEmail: 'ID, nome ou e-mail…',
    depositProof: 'Comprovante de depósito',
    depositProofPdf: 'PDF do comprovante de depósito',
    amount: 'Valor',
    method: 'Método',
    status: 'Status',
    trader: 'Trader',
    date: 'Data',
    actions: 'Ações',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    confirmApproval: 'Confirmar aprovação — isso creditará o saldo do trader.',
    confirmRejection: 'Confirmar rejeição — insira um motivo (opcional).',
    rejectionReason: 'Motivo da rejeição (opcional)…',
    approveSuccess: 'Depósito aprovado com sucesso',
    rejectSuccess: 'Depósito rejeitado com sucesso',
    failedToApprove: 'Falha ao aprovar depósito',
    failedToReject: 'Falha ao rejeitar depósito',
    noDepositsFound: 'Nenhum depósito encontrado',
    proofThumbnail: 'Miniatura do comprovante',
    zoomIn: 'Ampliar',
    zoomOut: 'Reduzir',
    openInNewTab: 'Abrir em nova aba',
    bank: 'Banco',
    crypto: 'Cripto',
    card: 'Cartão',
    bankPerCountry: 'Banco (Por País)',
    bankPerUser: 'Banco (Por Usuário)',
    bankTransfer: 'Transferência Bancária',
    bankTransferPerCountry: 'Transferência Bancária (Por País)',
    bankTransferPerUser: 'Transferência Bancária (Por Usuário)',
    averageDeposit: 'Depósito Médio',
  },

  // Withdrawals
  withdrawals: {
    title: 'Saques',
    allWithdrawals: 'Todos os Saques',
    allStatuses: 'Todos os Status',
    pending: 'Pendente',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
    completed: 'Concluído',
    searchPlaceholder: 'Pesquisar saques…',
    searchByIdNameEmail: 'Pesquisar por ID, nome do trader ou e-mail…',
    idNameOrEmail: 'ID, nome ou e-mail…',
    amount: 'Valor',
    method: 'Método',
    status: 'Status',
    trader: 'Trader',
    date: 'Data',
    actions: 'Ações',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    confirmApproval: 'Confirmar aprovação — os fundos serão liberados para os dados de pagamento do trader.',
    confirmWithdrawalApproval: 'Confirmar aprovação do saque — os fundos serão liberados para os dados de pagamento do trader.',
    confirmRejection: 'Confirmar rejeição — insira um motivo (opcional).',
    rejectionReason: 'Motivo da rejeição (opcional)…',
    approveSuccess: 'Saque aprovado com sucesso',
    rejectSuccess: 'Saque rejeitado com sucesso',
    failedToApprove: 'Falha ao aprovar saque',
    failedToReject: 'Falha ao rejeitar saque',
    noWithdrawalsFound: 'Nenhum saque encontrado',
    averageWithdrawal: 'Saque Médio',
  },

  // Audit Log
  auditLog: {
    title: 'Log de Auditoria',
    allActions: 'Todas as Ações',
    allEvents: 'Todos os Eventos',
    allLevels: 'Todos os Níveis',
    searchPlaceholder: 'Pesquisar log de auditoria…',
    emailActionOrId: 'E-mail, ação ou ID…',
    event: 'Evento',
    user: 'Usuário',
    action: 'Ação',
    timestamp: 'Timestamp',
    details: 'Detalhes',
    level: 'Nível',
    info: 'Informação',
    warning: 'Aviso',
    error: 'Erro',
    critical: 'Crítico',
    noLogsFound: 'Nenhum log de auditoria encontrado',
    administrativeAction: 'Uma ação administrativa foi registrada.',
    filterAuditLog: 'Filtrar Log de Auditoria',
    reset: 'Redefinir',
    eventType: 'Tipo de Evento',
    apply: 'Aplicar',
    totalEvents: 'Total de Eventos',
    depositEvents: 'Eventos de Depósito',
    withdrawalEvents: 'Eventos de Saque',
    noEventsMatch: 'Nenhum evento corresponde a este filtro',
    noEntriesMatch: 'Nenhuma entrada de auditoria corresponde ao filtro atual.',
    showAll: 'Mostrar tudo',
    events: 'evento',
    eventsPlural: 'eventos',
    totalEventsRecorded: 'Total de eventos registrados',
    performedBy: 'Realizado por',
    amount: 'Valor',
    paymentMethod: 'Método de Pagamento',
    balanceChange: 'Alteração de Saldo',
    statusChange: 'Alteração de Status',
    rejectionReason: 'Motivo da Rejeição',
    actionWithdrawalRequested: 'Saque Solicitado',
    actionDepositSubmitted: 'Depósito Enviado',
    actionProofUploaded: 'Comprovante Enviado',
    actionDepositApproved: 'Depósito Aprovado',
    actionDepositRejected: 'Depósito Rejeitado',
    actionWithdrawalApproved: 'Saque Aprovado',
    actionWithdrawalRejected: 'Saque Rejeitado',
    actionFundsLocked: 'Fundos Bloqueados',
    actionFundsReturned: 'Fundos Devolvidos',
    fundsLockedSummary: 'Fundos bloqueados da conta do trader aguardando revisão do saque.',
    fundsReturnedSummary: 'Fundos bloqueados foram devolvidos ao trader após rejeição.',
    depositsTab: 'Depósitos',
    withdrawalsTab: 'Saques',
  },

  // Plugins
  plugins: {
    title: 'Plugins',
    backToPlugins: 'Voltar aos Plugins',
    searchPlaceholder: 'Pesquisar plugins…',
    countrySelectNoMatch: 'Sem correspondência',
    configurePlugin: 'Configurar Plugin',
    pressEscToClose: 'Pressione {key} para fechar',
    loadingUsers: 'Carregando…',
    available: 'Disponível',
    active: 'Ativo',
    activate: 'Ativar',
    deactivate: 'Desativar',
    configure: 'Configurar',
    documentation: 'Documentação',
    settings: 'Configurações',
    noPluginsFound: 'Nenhum plugin encontrado',
    pluginDetails: 'Detalhes do Plugin',
    version: 'Versão',
    author: 'Autor',
    description: 'Descrição',
    filterInactive: 'Inativo',
    paymentGateways: 'Gateways de Pagamento',
    stripeTitle: 'Stripe',
    stripeDescription: 'Aceitar pagamentos via Stripe',
    paypalTitle: 'PayPal',
    paypalDescription: 'Aceitar pagamentos via PayPal',
    communicationTools: 'Ferramentas de Comunicação',
    twilioTitle: 'Twilio SMS',
    twilioDescription: 'Enviar notificações por SMS',
    mailgunTitle: 'Mailgun',
    mailgunDescription: 'Serviço de envio de e-mails',
    bankFieldAccountHolder: 'Titular da conta',
    bankFieldBankName: 'Nome do banco',
    bankFieldAccountNumber: 'Número da conta',
    bankFieldRoutingNumber: 'Número de roteamento (opcional)',
    bankFieldSetAsDefault: 'Definir como padrão (fallback global)',
    copyTradingTitle: 'Copy Trading',
    copyTradingDescription: 'Habilitar recursos de copy trading',
    tradingTools: 'Ferramentas de Negociação',
    mam: 'MAM/PAMM',
    apiKey: 'Chave de API',
    apiSecret: 'Segredo de API',
    accountSid: 'SID da Conta',
    authToken: 'Token de Autenticação',
    authDomain: 'Domínio de Autenticação',
    appId: 'ID do Aplicativo',
    loadingPlugins: 'Carregando plugins…',
    noPluginsMatch: 'Nenhum plugin corresponde aos seus critérios',
    tryDifferentSearch: 'Tente uma pesquisa ou filtro diferente',
    tryAdjustingSearch: 'Tente ajustar sua pesquisa ou filtro',
    activeCount: '{count} ativo(s) · {owned} possuído(s) · {available} na loja',
    ofPurchasedActive: '{count} de {count} comprados ativos',
    expired: 'Expirado',
    expires: 'Expira',
    free: 'Grátis',
    buyPlugin: 'Comprar — ${price}{cycle}',
    openInFullPage: 'Abrir em página completa',
    noConfigPanel: 'Nenhum painel de configuração disponível para este plugin.',
    currentStatus: 'Status Atual',
    failedToUpdateKyc: 'Falha ao atualizar configuração KYC',
    filterAll: 'Todos',
    filterActive: 'Ativos',
    filterOwned: 'Possuídos',
    filterStore: 'Loja',
    pluginNotFound: 'Plugin não encontrado',
    loadingPlugin: 'Carregando plugin...',
    failedToLoadPlugin: 'Falha ao carregar plugin',
    noConfigAvailable: 'Nenhum painel de configuração disponível para este plugin.',
    activeStatus: 'Ativo',
    editLabel: 'Editar',
    newLabel: 'Novo',
    addLabel: 'Adicionar',
    saveLabel: 'Salvar',
    cancelLabel: 'Cancelar',
    globalBankAccount: 'Conta Bancária Global',
    addBankAccount: 'Adicionar conta bancária',
    defaultLabel: '(padrão)',
    cryptoWallet: 'Carteira Cripto',
    addCryptoWallet: 'Adicionar carteira cripto',
    coinPlaceholder: 'Moeda (ex: BTC)',
    networkPlaceholder: 'Rede (ex: mainnet)',
    walletAddressPlaceholder: 'Endereço da carteira',
    labelOptionalPlaceholder: 'Rótulo (opcional)',
    paymentLink: 'Link de Pagamento',
    addPaymentLink: 'Adicionar link de pagamento',
    linkNamePlaceholder: 'Nome (ex: Stripe Checkout)',
    perUserBankAccount: 'Conta Bancária por Usuário',
    addUserBankMapping: 'Adicionar mapeamento usuário → banco',
    editExistingAccount: 'Editar conta existente',
    assignedUsers: 'Usuários atribuídos',
    pickTraders: 'Selecionar trader(s)',
    searchAddTrader: 'Pesquisar e adicionar trader…',
    perCountryBankAccount: 'Conta Bancária por País',
    addCountryBankMapping: 'Adicionar mapeamento país → banco',
    mappedCountries: 'Países mapeados',
    pickCountries: 'Selecionar país(es)',
    searchAddCountries: 'Pesquisar e adicionar países…',
    badgeActive: 'Ativo',
    badgeInactive: 'Inativo',
    badgeExpired: 'Expirado',
    purchasePlugin: 'Comprar Plugin',
    paymentMethod: 'Método de Pagamento',
    generatePaymentAddress: 'Gerar Endereço de Pagamento',
    sendExactly: 'Enviar exatamente',
    toAddressBelow: 'para o endereço abaixo',
    paymentAddress: 'Endereço de Pagamento',
    waitingForPayment: 'Aguardando pagamento...',
    paymentDetected: 'Pagamento detectado! Confirmando...',
    confirmationsReceived: '{count} confirmação recebida',
    confirmationsReceivedPlural: '{count} confirmações recebidas',
    expiresIn: 'Expira em:',
    paymentId: 'ID do Pagamento:',
    paymentConfirmed: 'Pagamento Confirmado!',
    pluginActivated: '{name} foi ativado.',
    networkError: 'Erro de rede. Por favor, tente novamente.',
    failedToCreatePayment: 'Falha ao criar pagamento',
    paymentExpired: 'Janela de pagamento expirada. Por favor, crie um novo pagamento.',
  },

  // API Docs
  apiDocs: {
    title: 'Documentação da API',
    authentication: 'Autenticação',
    baseUrl: 'URL Base:',
    allRequestsRequire: 'Todas as requisições requerem dois cabeçalhos:',
    apiKeyManagement: 'Gerenciamento de chaves de API com controles de escopo',
    billing: 'Faturamento',
    apiAccess: 'Acesso à API',
    apiAccessAddon: 'Add-on de Acesso à API ativo',
    buyAddon: 'Comprar Add-on — $199/mês',
    getAccounts: 'GET /accounts',
    getAccountDetails: 'GET /accounts/:id',
    updateAccount: 'PATCH /accounts/:id',
    getDeposits: 'GET /deposits',
    approveDeposit: 'POST /deposits/:id/approve',
    rejectDeposit: 'POST /deposits/:id/reject',
    getWithdrawals: 'GET /withdrawals',
    approveWithdrawal: 'POST /withdrawals/:id/approve',
    rejectWithdrawal: 'POST /withdrawals/:id/reject',
    approvalsDescription: 'Aprovar depósitos e saques programaticamente',
    approveDepositDesc: 'Aprovar depósito (status deve ser proof_uploaded). Credita o saldo da conta, registra a transação, notifica o motor. Corpo: notes?. Retorna balance_before e balance_after.',
    approveWithdrawalDesc: 'Aprovar um saque pendente. O saldo já foi bloqueado no momento da solicitação. Corpo: notes?',
    restApi: 'REST API',
    baseUrlLabel: 'URL Base:',
    yourApiKeys: 'Suas Chaves de API',
    noApiKeysYet: 'Nenhuma chave de API ainda',
    generateNewKey: 'Gerar Nova Chave',
    revokeKey: 'Revogar',
    rateLimit: 'Limite de taxa',
    maxKeys: 'Máximo de chaves',
    reqPerMin: '{limit} req/min',
    exampleRequest: 'Requisição de Exemplo',
    queryParameters: 'Parâmetros de Consulta',
    endpoints: 'endpoint',
    endpointsPlural: 'endpoints',
    includedInPlan: 'Incluído no seu plano Enterprise',
    addonActive: 'Add-on de Acesso à API ativo',
    restApiAccess: 'Acesso REST API',
    restApiDesc: 'O acesso REST API está disponível no plano Enterprise ou como um add-on independente para qualquer plano. Conecte seus sistemas diretamente à sua plataforma de corretagem.',
    featureReadClients: 'Ler clientes, contas e histórico de negociações',
    featureApprovePayments: 'Aprovar depósitos e saques programaticamente',
    featureApiKeyManagement: 'Gerenciamento de chaves de API com controles de escopo',
    featureRateLimit: 'Até 60 requisições por minuto por chave',
    featureInteractiveDocs: 'Documentação interativa no seu painel',
    upgradeToEnterprise: 'Atualizar para Enterprise',
    buyAddonPrice: 'Comprar Add-on — $199/mês',
    generateApiKey: 'Gerar Chave de API',
    keyName: 'Nome da Chave',
    keyNamePlaceholder: 'ex: Chave de Produção',
    scopes: 'Escopos',
    generating: 'Gerando...',
    generateKey: 'Gerar Chave',
    keyGenerated: 'Chave Gerada',
    copySecretWarning: '⚠️ Copie seu segredo agora — ele nunca será exibido novamente.',
    apiKeyLabel: 'Chave de API',
    apiSecretLabel: 'Segredo de API',
    done: 'Concluído',
    enterKeyName: 'Insira um nome para a chave',
    failedToCreateKey: 'Falha ao criar chave',
    keyRevoked: 'Chave revogada',
    confirmRevoke: 'Revogar esta chave de API? Esta ação não pode ser desfeita.',
  },

  // Notifications
  notifications: {
    title: 'Configurações de Notificações',
    emailNotifications: 'Notificações por E-mail',
    smsNotifications: 'Notificações por SMS',
    pushNotifications: 'Notificações Push',
    deposits: 'Depósitos',
    withdrawals: 'Saques',
    newClients: 'Novos Clientes',
    kycApplications: 'Solicitações KYC',
    systemAlerts: 'Alertas do Sistema',
    enabled: 'Habilitado',
    disabled: 'Desabilitado',
    saveSettings: 'Salvar Configurações',
    settingsSaved: 'Configurações salvas com sucesso',
    notificationChannels: 'Canais de Notificação',
    configureChannels: 'Configure como sua plataforma envia alertas aos clientes. Habilite apenas os canais que você configurou.',
    saveAll: 'Salvar Tudo',
    saving: 'Salvando...',
    enableToConfigure: 'Habilite para configurar {title}',
    emailSmtp: 'E-mail (SMTP)',
    emailSmtpSubtitle: 'Enviar e-mails via seu próprio servidor SMTP',
    recommended: 'Recomendado',
    smtpHost: 'Host SMTP',
    smtpPort: 'Porta SMTP',
    usernameEmail: 'Usuário / E-mail',
    passwordAppPassword: 'Senha / Senha do Aplicativo',
    fromEmail: 'E-mail Remetente',
    fromName: 'Nome Remetente',
    useTls: 'Usar TLS / STARTTLS',
    useTlsHint: 'Recomendado para porta 587. Desabilite para porta 465 (SSL).',
    sendTestEmail: 'Enviar E-mail de Teste',
    pushFcm: 'Notificações Push (FCM)',
    pushFcmSubtitle: 'Firebase Cloud Messaging para Android, iOS e Web',
    pushSetupRequired: 'Configuração necessária',
    pushSetupDesc: 'Acesse Firebase Console → Configurações do Projeto → Contas de Serviço → Gerar nova chave privada. Baixe o arquivo JSON e envie abaixo.',
    serviceAccountCredentials: 'Credenciais da Conta de Serviço',
    clientTokenStatus: 'Status do Token do Cliente',
    clientTokenDesc: 'Tokens push são registrados automaticamente quando os clientes fazem login no mobile/web. Nenhuma configuração manual necessária.',
    testPush: 'Testar Push',
    webAppConfig: 'Configuração do App Web',
    webAppConfigured: 'Configurado — {project}',
    webAppRequired: 'Necessário para push no navegador e mobile',
    webAppWhereToFind: 'Onde encontrar',
    webAppWhereToFindDesc: 'Firebase Console → Configurações do Projeto → Seus apps → App Web → Configuração do SDK',
    saveWebConfig: 'Salvar Configuração Web',
    vapidKey: 'Chave VAPID',
    vapidKeyHint: '— Aba Cloud Messaging → Certificados Web Push → Gerar par de chaves',
    credentialsOnFile: 'Credenciais arquivadas',
    credentialsStoredSecurely: 'Armazenadas com segurança no servidor',
    replaceCredentials: 'Substituir',
    uploadServiceAccount: 'Enviar JSON da conta de serviço',
    uploadServiceAccountHint: 'Clique para selecionar — o arquivo é validado e armazenado com segurança no servidor',
    uploadingValidating: 'Enviando e validando...',
    uploadSuccess: 'Credenciais do Firebase enviadas com sucesso',
    uploadFailed: 'Falha no envio — verifique se o arquivo é um JSON válido de conta de serviço do Firebase',
    saveWebConfigSuccess: 'Configuração web do Firebase salva',
    saveWebConfigFailed: 'Falha ao salvar configuração web',
    smsTwilio: 'SMS (Twilio)',
    smsTwilioSubtitle: 'Enviar alertas por SMS via Twilio para clientes com números de telefone',
    smsSetupRequired: 'Configuração necessária',
    smsSetupDesc: 'Obtenha suas credenciais em console.twilio.com → Conta → Chaves de API e tokens. Você também precisará de um número de telefone Twilio.',
    accountSid: 'SID da Conta',
    accountSidHint: 'Começa com AC...',
    authToken: 'Token de Autenticação',
    fromPhoneNumber: 'Número de Telefone Remetente',
    fromPhoneHint: 'Formato E.164, ex: +5511999999999',
    sendTestSms: 'Enviar SMS de Teste',
    statusConnected: 'Conectado',
    statusError: 'Erro',
    statusUntested: 'Não Testado',
    statusTesting: 'Testando...',
    notificationRouting: 'Roteamento de Notificações',
    notificationRoutingDesc: 'Escolha quais canais cada tipo de notificação usa',
    noChannelsEnabled: 'Nenhum canal habilitado',
    noChannelsEnabledDesc: 'Habilite pelo menos um canal acima para configurar o roteamento de notificações',
    notifMarginCall: 'Chamada de Margem',
    notifMarginCallDesc: 'Quando o nível de margem da conta cai abaixo do limite',
    notifLiquidation: 'Liquidação',
    notifLiquidationDesc: 'Quando posições são fechadas à força',
    notifDeposit: 'Depósito',
    notifDepositDesc: 'Quando um depósito é confirmado',
    notifWithdrawal: 'Saque',
    notifWithdrawalDesc: 'Quando um saque é processado',
    notifTradeOpened: 'Negociação Aberta',
    notifTradeOpenedDesc: 'Quando uma nova posição é aberta',
    notifTradeClosed: 'Negociação Fechada',
    notifTradeClosedDesc: 'Quando uma posição é fechada',
    failedToLoad: 'Falha ao carregar configurações de notificações',
    failedToSave: 'Falha ao salvar',
    testSuccess: 'Teste de {channel} bem-sucedido — verifique sua caixa de entrada/dispositivo',
    testFailed: 'Teste de {channel} falhou',
  },

  // Upgrade
  upgrade: {
    title: 'Atualizar Plano',
    currentPlan: 'Plano Atual',
    choosePlan: 'Escolher Plano',
    basic: 'Básico',
    professional: 'Profissional',
    enterprise: 'Enterprise',
    perMonth: '/mês',
    perYear: '/ano',
    monthly: 'Mensal',
    annually: 'Anual',
    features: 'Recursos',
    selectPlan: 'Selecionar Plano',
    currentPlanLabel: 'Plano Atual',
    upgradeTo: 'Atualizar para',
    contactSales: 'Falar com Vendas',
    unlimitedClients: 'Clientes Ilimitados',
    unlimitedAccounts: 'Contas Ilimitadas',
    advancedReporting: 'Relatórios Avançados',
    prioritySupport: 'Suporte Prioritário',
    apiAccess: 'Acesso à API',
    customBranding: 'Marca Personalizada',
    whiteLabel: 'White Label',
    dedicatedManager: 'Gerente de Conta Dedicado',
    upgradeAvailable: 'Atualização Disponível',
    plan: 'Plano',
    unlock: 'Desbloquear',
    apiAccessFeature: ', acesso à API',
    andMore: '& mais',
    renew: 'Renovar',
  },

  // Theme
  theme: {
    light: 'Modo Claro',
    dark: 'Modo Escuro',
    toggle: 'Alternar Tema',
  },

  // Language
  language: {
    english: 'English',
    arabic: 'العربية',
    turkish: 'Türkçe',
    select: 'Selecionar Idioma',
  },

  // Errors
  errors: {
    general: 'Algo deu errado',
    networkError: 'Erro de rede. Verifique sua conexão.',
    unauthorized: 'Não autorizado. Por favor, entre novamente.',
    forbidden: 'Acesso negado.',
    notFound: 'Recurso não encontrado.',
    serverError: 'Erro no servidor. Tente novamente mais tarde.',
    actionFailed: 'Ação falhou',
  },

  // Success messages
  success: {
    saved: 'Salvo com sucesso',
    updated: 'Atualizado com sucesso',
    deleted: 'Excluído com sucesso',
    created: 'Criado com sucesso',
    copied: 'Copiado para área de transferência',
  },

  // Time & Date
  time: {
    seconds: 'segundos',
    minutes: 'minutos',
    hours: 'horas',
    days: 'dias',
    weeks: 'semanas',
    months: 'meses',
    years: 'anos',
    ago: 'atrás',
    justNow: 'agora mesmo',
    today: 'Hoje',
    yesterday: 'Ontem',
    tomorrow: 'Amanhã',
  },

  // Units
  units: {
    usd: 'USD',
    eur: 'EUR',
    gbp: 'GBP',
    lot: 'lote',
    lots: 'lotes',
    pips: 'pips',
    percent: '%',
  },

  cascade: {
    settingsArchitecture: 'Arquitetura de Configurações',
    title: 'Sistema de Prioridade em Cascata',
    subtitle: 'As configurações são resolvidas da maior → menor prioridade. Deixe um campo',
    subtitleNull: 'vazio (NULL)',
    subtitleFallthrough: 'para pular essa camada e passar para a próxima.',
    resolutionOrder: 'Ordem de resolução:',
    firstNonNull: 'Primeiro valor não nulo vence',
    highestPriority: 'Maior Prioridade — Clique em qualquer camada para explorar',
    ifEmptyFallsThrough: '↓ se vazio, passa adiante',
    priority: 'Prioridade',
    leaveFieldEmpty: 'Deixe qualquer campo vazio (NULL)',
    skipLayer: 'para pular esta camada e passar para',
    finalFallback: 'Fallback final — nenhuma camada abaixo.',
    hardLimitsNote: 'Campos marcados com',
    hardLimitsNote2: 'são limites rígidos aplicados em todo o sistema, nenhuma camada pode contorná-los.',
    layers: {
      userOverride: 'Substituição de Usuário',
      userSublabel: 'Acordos especiais por cliente',
      userTooltip: 'Maior prioridade. Qualquer campo definido aqui prevalece sobre tudo. Use para clientes VIP, contas restritas ou acordos especiais.',
      userFallsTo: 'Grupo de Conta (P2)',
      accountGroup: 'Grupo de Conta',
      groupSublabel: 'Níveis VIP, Padrão, Profissional',
      groupTooltip: 'Aplicado a todos os clientes deste grupo. Se não houver substituição de usuário, as configurações do grupo se aplicam. Ótimo para tipos de conta em camadas.',
      groupFallsTo: 'Configurações do Símbolo (P3)',
      symbolSettings: 'Configurações do Símbolo',
      symbolSublabel: 'Config da corretora por instrumento',
      symbolTooltip: 'Controla regras de precificação e execução por instrumento. Ex: XAUUSD tem markup de spread diferente do EURUSD.',
      symbolFallsTo: 'Padrões da Plataforma (P4)',
      platformDefaults: 'Padrões da Plataforma',
      platformSublabel: 'Fallback do sistema e limites rígidos',
      platformTooltip: 'Menor prioridade para padrões, mas aplica limites rígidos absolutos que nenhuma outra camada pode substituir. Gerenciado apenas pelo administrador do sistema.',
    },
    setByBroker: 'Definido pela Corretora',
    setBySystemAdmin: 'Definido pelo Administrador do Sistema',
    goToClients: 'Ir para Clientes',
    goToAccountGroups: 'Ir para Grupos de Contas',
    goToInstruments: 'Ir para Instrumentos',
    fields: {
      maxLeverage: 'Alavancagem Máxima',
      maxLotSize: 'Tamanho Máximo de Lote',
      marginCallLevel: 'Nível de Chamada de Margem',
      stopOutLevel: 'Nível de Stop Out',
      maxOpenPositions: 'Máximo de Posições Abertas',
      commissionPerLot: 'Comissão por Lote',
      tradingDisabled: 'Negociação Desabilitada',
      spreadMarkup: 'Markup de Spread',
      swapMarkup: 'Markup de Swap',
      tripleSwapDay: 'Dia de Swap Triplo',
      stopLevel: 'Nível de Stop',
      freezeLevel: 'Nível de Congelamento',
      defaultLeverage: 'Alavancagem Padrão',
      defaultCommission: 'Comissão Padrão',
      defaultMarginCall: 'Chamada de Margem Padrão',
      defaultStopOut: 'Stop Out Padrão',
      maxLeverageCap: 'Limite Máximo de Alavancagem',
      minMarginCall: 'Chamada de Margem Mínima',
      minStopOut: 'Stop Out Mínimo',
      maxCommissionCap: 'Limite Máximo de Comissão',
      maxPositionsCap: 'Limite Máximo de Posições',
    },
    fieldDescs: {
      capLeverageClient: 'Limitar alavancagem para este cliente específico',
      limitPositionSize: 'Limitar tamanho de posição por negociação',
      overrideAlertThreshold: 'Substituir limite de alerta',
      overrideAutoClose: 'Substituir limite de fechamento automático',
      limitConcurrentTrades: 'Limitar negociações simultâneas',
      customCommission: 'Taxa de comissão personalizada (ex: VIP = 0)',
      killSwitch: 'Interruptor de emergência para este cliente',
      groupCommission: 'Taxa de comissão para o grupo',
      groupLeverage: 'Limite de alavancagem do grupo',
      groupMarginCall: 'Limite de alerta do grupo',
      groupStopOut: 'Limite de fechamento automático do grupo',
      groupPositions: 'Limite de posições do grupo',
      groupLotSize: 'Limite de tamanho de negociação do grupo',
      pipsAddedSpread: 'Pips adicionados ao spread bruto',
      symbolCommission: 'Comissão específica do símbolo',
      overnightSwap: 'Adicionado às taxas de swap overnight',
      tripleSwapDay: 'Dia em que o swap triplo é cobrado',
      symbolLeverage: 'Limite de alavancagem do símbolo',
      symbolLotSize: 'Limite de tamanho de negociação do símbolo',
      minSlTpDistance: 'Distância mínima de SL/TP em pips',
      modificationFreeze: 'Distância de congelamento de modificação',
      fallbackLeverage: 'Fallback se nenhuma camada definir',
      fallbackCommission: 'Taxa de comissão de fallback',
      fallbackMarginCall: 'Nível de alerta de fallback',
      fallbackStopOut: 'Nível de fechamento automático de fallback',
      hardCeilingLeverage: 'Limite rígido — nenhuma camada pode exceder',
      hardFloorMarginCall: 'Piso rígido — nenhuma camada pode ficar abaixo',
      hardFloorStopOut: 'Piso rígido — nenhuma camada pode ficar abaixo',
      hardCeilingCommission: 'Limite rígido de comissão',
      systemPositionLimit: 'Limite de posições em todo o sistema',
    },
  },

  emailTemplates: {
    loadingTemplates: 'Carregando modelos de e-mail…',
    loadingTemplate: 'Carregando modelo…',
    retry: 'Tentar novamente',
    allTemplates: '← Todos os Modelos',
    customised: 'Personalizado',
    custom: 'Personalizado',
    default: 'Padrão',
    subjectLine: 'Assunto do E-mail',
    subjectPlaceholder: 'Assunto do e-mail…',
    editorTab: 'Editor',
    htmlTab: 'HTML',
    previewTab: 'Visualizar',
    variables: 'Variáveis:',
    showLess: 'Mostrar menos',
    clickToInsert: 'Clique para inserir variável:',
    saveTemplate: 'Salvar Modelo',
    savingTemplate: 'Salvando…',
    resetToDefault: 'Restaurar Padrão',
    resetting: 'Restaurando…',
    back: 'Voltar',
    resetConfirm: 'Restaurar o modelo premium padrão? Suas personalizações serão perdidas.',
    subjectBodyRequired: 'Assunto e corpo são obrigatórios',
    activeBranding: 'Identidade Visual Ativa',
    companyName: 'Nome da Empresa',
    primaryColor: 'Cor Principal',
    logoUrl: 'URL do Logo',
    noLogoSet: 'Nenhum logo definido',
    emailFooter: 'Rodapé do E-mail',
    brandingNote: 'Para atualizar sua identidade visual, acesse as Configurações da Corretora. As alterações se aplicam a todos os modelos de e-mail automaticamente.',
    editBranding: 'Editar Identidade Visual',
    closeBranding: 'Fechar Identidade Visual',
    templateListDesc: 'Clique em um modelo para editar. Modelos personalizados substituem os padrões premium.',
    templateInfoNote: 'Modelos marcados como Padrão usam o design premium integrado com sua identidade visual aplicada. Clique em qualquer modelo para personalizá-lo. Use Restaurar Padrão no editor para reverter suas alterações.',
    loadingBranding: 'Carregando identidade visual…',
    typeDepositApproved: 'Depósito Aprovado',
    typeDepositRejected: 'Depósito Rejeitado',
    typeWithdrawalApproved: 'Saque Aprovado',
    typeWithdrawalRejected: 'Saque Rejeitado',
    typeMarginCall: 'Chamada de Margem',
    typeLiquidation: 'Conta Liquidada',
    typeKycApproved: 'KYC Aprovado',
    typeKycRejected: 'KYC Rejeitado',
    typeWelcome: 'E-mail de Boas-vindas',
  },

  credits: {
    activeRules: 'Regras Ativas',
    totalAwarded: 'Total Concedido',
    awardEvents: 'Eventos de Concessão',
    bonusRules: 'Regras de Bônus',
    awardHistory: 'Histórico de Concessões',
    newRule: 'Nova regra',
    manualAward: 'Concessão manual',
    noBonusRules: 'Nenhuma regra de bônus ainda. Adicione uma para começar a conceder crédito automaticamente em depósitos.',
    noCreditAwards: 'Nenhuma concessão de crédito ainda.',
    deactivateConfirm: 'Desativar esta regra?',
    revokeReason: 'Motivo da revogação (opcional):',
    operationFailed: 'Operação falhou',
    bonusRuleTitle: 'Regra de Bônus {mode}',
    ruleName: 'Nome da regra (ex: Bônus de Boas-vindas)',
    percentOfDeposit: '% do depósito (ex: 20)',
    fixedAmountUsd: 'Valor fixo (USD)',
    maxCreditCap: 'Limite máximo de crédito (opcional)',
    minDepositQualify: 'Depósito mínimo para qualificar',
    expiresAfterDays: 'Expira após N dias (opcional)',
    ruleActive: 'Ativo — concede automaticamente em depósitos qualificados',
    ruleDisabled: 'Desabilitado',
    savingDots: 'Salvando…',
    awardingDots: 'Concedendo…',
    manualCreditAward: 'Concessão Manual de Crédito',
    accountId: 'ID da Conta',
    userId: 'ID do Usuário',
    amountUsd: 'Valor (USD)',
    notesOptional: 'Observações (opcional)',
    awardCredit: 'Conceder Crédito',
    infoWelcomeDeposit: 'Regras BOAS-VINDAS e DEPÓSITO disparam automaticamente na aprovação do depósito. GOODWILL e PROMOÇÃO são concedidos manualmente. O crédito é zerado na liquidação.',
    bonusWelcome: 'Boas-vindas',
    bonusDeposit: 'Depósito',
    bonusGoodwill: 'Goodwill',
    bonusPromotion: 'Promoção',
    statusRevoked: 'Revogado',
    statusExpired: 'Expirado',
  },

  pages: {
    websitePages: 'Páginas do Site',
    websitePagesDesc: 'Construa e gerencie seu site.',
    pluginNotActive: 'Plugin não ativo.',
    viewPlugins: 'Ver Plugins',
    mainPages: 'Páginas Principais',
    legalPages: 'Páginas Legais',
    langs: 'idiomas',
    save: 'Salvar',
    saved: 'Salvo',
    error: 'Erro',
    publish: 'Publicar',
    unpublish: 'Despublicar',
    published: 'Publicado',
    draft: 'Rascunho',
    tabBlocks: 'Blocos',
    tabSeo: 'SEO',
    addBlock: 'Adicionar Bloco',
    addFirstBlock: 'Adicionar Primeiro Bloco',
    addFirstBlockHint: 'Adicione seu primeiro bloco de conteúdo',
    noBlocks: 'Nenhum bloco ainda',
    pageTitle: 'Título da Página',
    pageTitleHint: 'Este é o título principal da página exibido na navegação e no cabeçalho',
    translatable: 'Traduzível',
    pageSlug: 'Slug da Página',
    seoTitle: 'Título SEO',
    seoDescription: 'Descrição SEO',
    googlePreview: 'PRÉVIA DO GOOGLE',
    noDescription: 'Sem descrição.',
    catHeroLayout: 'Hero e Layout',
    catContent: 'Conteúdo',
    catFeaturesData: 'Recursos e Dados',
    catSocialProof: 'Prova Social',
    catCta: 'Chamada para Ação',
    catDocuments: 'Documentos e Jurídico',
    catOther: 'Outros',
    missing: 'Ausente',
    add: 'Adicionar',
    addItem: 'Adicionar Item',
    item: 'Item',
    notStarted: 'Não iniciado',
  },

  userOverride: {
    title: 'Substituição de Conta do Usuário',
    infoBannerTitle: 'Substituições em Nível de Usuário (Camada 1)',
    infoBannerDesc: 'Essas configurações substituem os padrões do grupo de conta do usuário. Deixe os campos vazios (NULL) para usar as configurações do grupo.',
    sectionTradingControl: 'Controle de Negociação',
    sectionRiskParameters: 'Parâmetros de Risco',
    sectionPricingOverrides: 'Substituições de Preço',
    disableTrading: 'Desabilitar Negociação',
    disableTradingSubLabel: 'Impedir este usuário de abrir novas posições',
    resetToGroupDefault: 'Redefinir para Padrão do Grupo',
    groupDefault: 'Padrão do Grupo',
    maxLeverage: 'Alavancagem Máxima',
    maxLotSize: 'Tamanho Máximo de Lote',
    minLotSize: 'Tamanho Mínimo de Lote',
    marginCallLevel: 'Nível de Chamada de Margem (%)',
    stopOutLevel: 'Nível de Stop Out (%)',
    maxOpenPositions: 'Máximo de Posições Abertas',
    commissionPerLot: 'Comissão por Lote (USD)',
    commissionPerLotHint: 'USD cobrado por lote padrão negociado',
    minAboveMaxError: '⚠️ Tamanho mínimo de lote não pode exceder o máximo',
    currentOverrideTitle: 'Substituição Atual Ativa',
    currentOverrideDesc: 'Este usuário tem configurações personalizadas que substituem os padrões do seu grupo de conta.',
    saveOverride: 'Salvar Substituição',
    saving: 'Salvando...',
    saveSuccess: 'Substituição de usuário salva com sucesso',
    saveFailed: 'Falha ao salvar substituição de usuário',
    lots: 'lotes',
    lotStep: 'Pas de lot',
  },

  symbolSettings: {
    sectionPricing: 'Precificação da Corretora',
    sectionRisk: 'Limites de Risco',
    sectionExecution: 'Regras de Execução',
    sectionOverrides: 'Substituições do Instrumento',
    sectionsLabel: 'Seções',
    pricingDesc: 'Ajustes aplicados sobre as taxas brutas do instrumento para esta corretora.',
    riskDesc: 'Limites de posição e alavancagem aplicados neste nível de corretora.',
    executionDesc: 'Restrições de colocação e modificação de ordens.',
    overridesDesc: 'Alterne cada campo para ativar uma substituição em nível de corretora. Campos desabilitados usam a tabela compartilhada de instrumentos.',
    overridesInfoTitle: 'Swap Longo / Swap Curto',
    overridesInfoDesc: 'substituem completamente a taxa do instrumento quando habilitados — o markup de swap não é adicionado por cima. Todas as outras substituições fazem cascata normalmente.',
    settingsTitle: 'Configurações de {symbol}',
    headerSubtitle: 'Configurar precificação e risco em nível de corretora (Camada 3)',
    overrideActive: '{count} substituição ativa',
    overridesActive: '{count} substituições ativas',
    spreadMarkup: 'Markup de Spread',
    spreadMarkupHint: 'Pips adicionados ao spread bruto do provedor de liquidez',
    commissionPerLot: 'Comissão por Lote',
    commissionPerLotHint: 'USD cobrado por lote padrão negociado',
    swapMarkup: 'Markup de Swap',
    swapMarkupHint: 'Pontos adicionados às taxas de swap do instrumento. Ignorado quando substituições de swap_long / swap_short estão habilitadas.',
    tripleSwapDay: 'Dia de Swap Triplo',
    tripleSwapDayHint: 'Dia em que o swap triplo é cobrado',
    maxLeverage: 'Alavancagem Máxima',
    maxLeverageHint: 'Alavancagem máxima permitida para este símbolo',
    maxLotSize: 'Tamanho Máximo de Lote',
    maxLotSizeHint: 'Tamanho máximo de posição por negociação',
    minLotSize: 'Tamanho Mínimo de Lote',
    minLotSizeHint: 'Tamanho mínimo de posição por negociação',
    minAboveMaxError: '⚠️ Tamanho mínimo de lote não pode exceder o máximo',
    stopLevel: 'Nível de Stop',
    stopLevelHint: 'Distância mínima para SL/TP do preço de mercado atual (pips)',
    freezeLevel: 'Nível de Congelamento',
    freezeLevelHint: 'Distância em que modificações de ordens são congeladas (pips)',
    contractSize: 'Tamanho do Contrato',
    contractSizeHint: 'Unidades por lote. ex: 100000 para forex padrão, 1 para ações.',
    priceScale: 'Escala de Preço',
    priceScaleHint: 'Casas decimais para cotação de preço. 5 = 1.23456, 2 = 1.23.',
    swapLong: 'Swap Longo (taxa direta)',
    swapLongHint: 'Taxa overnight para posições de COMPRA. Substitui completamente a taxa do instrumento.',
    swapShort: 'Swap Curto (taxa direta)',
    swapShortHint: 'Taxa overnight para posições de VENDA. Substitui completamente a taxa do instrumento.',
    swapMode: 'Modo de Swap',
    swapModeHint: 'Como a taxa de swap overnight é calculada',
    maxVolume: 'Volume Máximo (lotes)',
    maxVolumeHint: 'Tamanho máximo de negociação única em lotes para esta corretora.',
    volumeStep: 'Incremento de Volume (lotes)',
    volumeStepHint: 'Incremento mínimo de tamanho de negociação. ex: 0.01 permite 0.01, 0.02, 0.03…',
    defaultBadge: 'padrão',
    pips: 'pips',
    pts: 'pts',
    lots: 'lotes',
    decimals: 'decimais',
    dayMon: 'Seg',
    dayTue: 'Ter',
    dayWed: 'Qua',
    dayThu: 'Qui',
    dayFri: 'Sex',
    daySat: 'Sáb',
    daySun: 'Dom',
    loadingSettings: 'Carregando configurações…',
    saveSettings: 'Salvar Configurações',
    lotStep: 'Pas de lot',
  },

  accountGroupForm: {
    sectionsLabel: 'Seções',
    sectionBasic: 'Informações Básicas',
    sectionPricing: 'Substituições de Preço',
    sectionRisk: 'Gestão de Risco',
    editTitle: 'Editar Grupo de Contas',
    createTitle: 'Criar Grupo de Contas',
    basicInfoTitle: 'Informações Básicas',
    groupNameLabel: 'Nome do Grupo *',
    groupNamePlaceholder: 'Grupo Padrão',
    descriptionLabel: 'Descrição',
    descriptionPlaceholder: 'Descrição do grupo...',
    groupActive: 'Grupo Ativo',
    defaultGroup: 'Grupo Padrão',
    pricingTitle: 'Substituições de Preço',
    pricingDesc: 'Deixe em branco para usar os padrões da corretora. Substitua apenas se este grupo precisar de preços diferentes.',
    commissionPerLot: 'Comissão por Lote (USD)',
    commissionPerLotHint: 'USD cobrado por lote padrão negociado',
    maxLeverage: 'Alavancagem Máxima',
    maxLeverageHint: 'Alavancagem máxima disponível para este grupo',
    brokerDefault: 'Padrão da Corretora',
    resetToNoLimit: 'Redefinir para sem limite',
    riskTitle: 'Gestão de Risco',
    marginCallLevel: 'Nível de Chamada de Margem',
    marginCallHint: 'Alertar quando o nível de margem atingir esta porcentagem',
    stopOutLevel: 'Nível de Stop Out',
    stopOutHint: 'Fechar posições automaticamente neste nível de margem',
    maxOpenPositions: 'Máximo de Posições Abertas',
    maxOpenPositionsHint: 'Número máximo de posições por conta',
    maxLotSize: 'Tamanho Máximo de Lote',
    maxLotSizeHint: 'Tamanho máximo de lote por negociação',
    minLotSize: 'Tamanho Mínimo de Lote',
    minLotSizeHint: 'Tamanho mínimo de lote por negociação para este grupo',
    noLimit: 'Sem Limite',
    lots: 'lotes',
    marginBelowStopError: '⚠️ Nível de Chamada de Margem deve ser maior que o Nível de Stop Out',
    minAboveMaxError: '⚠️ Tamanho mínimo de lote não pode exceder o máximo',
    updateGroup: 'Atualizar Grupo',
    createGroup: 'Criar Grupo',
    lotStep: 'Pas de lot',
  },

  cryptoCheckout: {
    paymentConfirmedTitle: 'Pagamento Confirmado!',
    makePayment: 'Fazer Pagamento',
    depositFunds: 'Depositar Fundos',
    purchaseItem: 'Comprar {name}',
    subscribeTo: 'Assinar {name}',
    selectPaymentMethod: 'Selecionar método de pagamento',
    payWith: 'Pagar com {currencies}',
    creatingPayment: 'Criando pagamento...',
    continue: 'Continuar',
    sendExactly: 'Enviar exatamente',
    approxUsd: '≈ ${amount} USD',
    hideQrCode: 'Ocultar QR Code',
    showQrCode: 'Mostrar QR Code',
    scanWithWallet: 'Escaneie com sua carteira mobile',
    toThisAddress: 'Para este endereço {network}',
    expiresIn: 'Expira em',
    waitingForPayment: 'Aguardando pagamento...',
    waitingDesc: 'Envie o valor exato. Detectaremos automaticamente.',
    verifiedOnChain: 'Verificado on-chain pela AmorPay. Sem intermediários.',
    pluginActivated: '{name} foi ativado.',
    depositCredited: 'Seu depósito foi creditado na sua conta.',
    subscriptionActive: 'Sua assinatura está ativa.',
    paymentConfirmed: 'Seu pagamento foi confirmado.',
    done: 'Concluído',
    noItemSelected: 'Nenhum item selecionado para compra',
    failedToLoadOptions: 'Falha ao carregar opções de pagamento',
  },

  subscriptionGate: {
    accountSuspended: 'Conta Suspensa',
    subscriptionExpired: 'Assinatura Expirada',
    suspendedDesc: 'Sua conta foi suspensa. Entre em contato com o suporte para restaurar o acesso.',
    expiredDesc: 'Sua assinatura {plan} expirou e o período de carência terminou. Renove para restaurar o acesso completo.',
    renewSubscription: 'Renovar Assinatura',
    signOut: 'Sair',
    needHelp: 'Precisa de ajuda? Entre em contato com',
    lastChance: '⚠️ Última chance! Sua assinatura {plan} expirou. O acesso termina hoje.',
    gracePeriodDay: 'Sua assinatura {plan} expirou. Você tem {days} dia restante no período de carência.',
    gracePeriodDays: 'Sua assinatura {plan} expirou. Você tem {days} dias restantes no período de carência.',
    renewNow: 'Renovar Agora',
  },

  upgradePage: {
    renewTitle: 'Renovar Assinatura',
    upgradeTitle: 'Atualizar Seu Plano',
    currentlyOn: 'Atualmente em',
    graceDaysLeft: '{days} dia restante no período de carência',
    graceDaysLeftPlural: '{days} dias restantes no período de carência',
    expired: 'Expirado',
    graceWarning: 'Sua assinatura expirou. Você tem {days} dia para renovar antes que sua conta seja bloqueada.',
    graceWarningPlural: 'Sua assinatura expirou. Você tem {days} dias para renovar antes que sua conta seja bloqueada.',
    expiredWarning: 'Sua assinatura expirou completamente. Renove agora para restaurar o acesso.',
    renewOrUpgrade: 'Você pode renovar seu plano atual ou atualizar para um nível superior.',
    monthly: 'Mensal',
    yearly: 'Anual',
    mostPopular: 'Mais Popular',
    currentPlan: 'Plano Atual',
    perMonth: '/mês',
    saveYearly: 'Economize 10% — cobrado ${amount}/ano',
    unlimitedTraders: 'Traders ilimitados',
    tradersCount: '{count} traders',
    unlimitedAdmins: 'Admins ilimitados',
    adminsCount: '{count} admins',
    unlimitedInstruments: 'Instrumentos ilimitados',
    instrumentsCount: '{count} instrumentos',
    feedUltra: 'Feed de latência ultra baixa',
    feedPriority: 'Feed prioritário',
    feedStandard: 'Feed padrão',
    fullApiAccess: 'Acesso completo à API',
    selected: 'Selecionado',
    selectPlan: 'Selecionar Plano',
    fullComparison: 'Comparação completa',
    featureCol: 'Recurso',
    featureTraders: 'Traders',
    featureAdmins: 'Admins',
    featureInstruments: 'Instrumentos',
    featureFeedLatency: 'Latência do Feed',
    featureApiAccess: 'Acesso à API',
    featureForex: 'Forex',
    featureCrypto: 'Cripto',
    featureCommodities: 'Commodities',
    featureIndices: 'Índices',
    featureStocks: 'Ações',
    selectedPlan: 'Selecionado:',
    selectToContinue: 'Selecione um plano para continuar',
    perYear: '/ano',
    renewNow: 'Renovar Agora',
    upgradeNow: 'Atualizar Agora',
    failedToLoadPlans: 'Falha ao carregar planos',
    selectPlanFirst: 'Por favor, selecione um plano primeiro',
    planActivated: 'Plano {name} ativado! 🎉',
  },

  sidebar: {
    sectionOverview: 'Visão geral',
    sectionManagement: 'Gestão',
    sectionTrading: 'Trading',
    sectionFinance: 'Finanças',
    sectionPlugins: 'Plugins',
    sectionSystem: 'Sistema',
    accountGroups: 'Grupos de contas',
    cascadeGuide: 'Guia em cascata',
    pluginStore: 'Loja de plugins',
    kycVerification: 'Verificação KYC',
    kycDashboard: 'Painel KYC',
    kycConfig: 'Config KYC',
    pages: 'Páginas',
    credits: 'Créditos',
    emailTemplates: 'Modelos de e-mail',
    restApi: 'REST API',
    advancedAnalytics: 'Análise avançada',
    descClients: 'Usuários · Configurações · Substituições',
    descGroups: 'Grupos · Configurações · Substituições',
    descInstruments: 'Corretor · Configurações · Substituições',
    descAccounts: 'Contas e saldos',
    descCascade: 'Sistema de prioridade explicado',
    descAnalytics: 'Insights com inteligência artificial',
    badgeLive: 'Ao vivo',
    badgeActive: 'Ativo',
    badgeAddon: 'Complemento',
    badgePro: 'PRO',
    badgeApi: 'API',
    badgeConfig: 'Config',
    badgeHowItWorks: 'Como funciona',
    cascadeTipFallthrough: 'Deixe os campos vazios para passar para a próxima camada',
  },
};